type UseIdsSessionType = {
    isIdsSession: boolean;
    hookUrl?: string;
    idsVersion?: string;
    returnTarget?: string;
};

const LOCAL_STORAGE_KEY = 'idsSession';

export const useIdsSession = (): UseIdsSessionType => {
    if (typeof window === 'undefined') {
        return { isIdsSession: false };
    }

    const idsSessionString = localStorage.getItem(LOCAL_STORAGE_KEY);

    if (idsSessionString) {
        const sessionData = JSON.parse(idsSessionString);

        return {
            isIdsSession: true,
            hookUrl: sessionData.hookUrl,
            idsVersion: sessionData.idsVersion,
            returnTarget: sessionData.returnTarget
        };
    }

    return { isIdsSession: false };
};
